module.exports = __webpack_public_path__ + "img/ueg_logo.9d38baae.svg";